/**
 * Direct course status check
 */

import { get } from '@aws-amplify/api-rest';
import { fetchAuthSession } from 'aws-amplify/auth';

export async function directCourseCheck() {
  console.log('🔍 DIRECT COURSE STATUS CHECK');
  console.log('=' .repeat(50));
  
  try {
    const session = await fetchAuthSession();
    const token = session.tokens.idToken.toString();
    
    // Check the specific test course
    const TEST_ID = '045ef510-0d3d-41f7-808e-e75a77cb765c';
    console.log('\n1️⃣ Checking test course:', TEST_ID);
    
    const testResponse = await get({
      apiName: 'CourseBookingApi',
      path: `courses/${TEST_ID}`,
      options: {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    });
    
    // Parse response
    let testCourse = testResponse;
    if (testResponse.response) testCourse = await testResponse.response;
    if (testCourse.json) testCourse = await testCourse.json();
    if (testCourse.body && testCourse.body.text) {
      const bodyText = await testCourse.body.text();
      testCourse = JSON.parse(bodyText);
    } else if (typeof testCourse.body === 'string') {
      testCourse = JSON.parse(testCourse.body);
    }
    
    console.log('Test course:');
    console.log('  Title:', testCourse.title);
    console.log('  Status:', testCourse.status);
    console.log('  Status type:', typeof testCourse.status);
    console.log('  Status JSON:', JSON.stringify(testCourse.status));
    console.log('  Available:', testCourse.availableSpots);
    
    // Get all courses
    console.log('\n2️⃣ Getting all courses...');
    const allResponse = await get({
      apiName: 'CourseBookingApi',
      path: 'courses',
      options: {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    });
    
    // Parse response
    let allCourses = allResponse;
    if (allResponse.response) allCourses = await allResponse.response;
    if (allCourses.json) allCourses = await allCourses.json();
    if (allCourses.body && allCourses.body.text) {
      const bodyText = await allCourses.body.text();
      allCourses = JSON.parse(bodyText);
    } else if (typeof allCourses.body === 'string') {
      allCourses = JSON.parse(allCourses.body);
    }
    if (allCourses.courses) allCourses = allCourses.courses;
    
    if (Array.isArray(allCourses)) {
      console.log(`Found ${allCourses.length} courses:`);
      
      for (const course of allCourses) {
        console.log(`\n📚 ${course.title || 'Untitled'}`);
        console.log('  ID:', course.courseId || course.id);
        console.log('  Status:', course.status);
        console.log('  Available:', course.availableSpots);
        
        // Check if this is our test course
        if ((course.courseId || course.id) === TEST_ID) {
          console.log('  ⚠️ THIS IS THE TEST COURSE!');
          console.log('  List status:', course.status);
          console.log('  Detail status:', testCourse.status);
          if (course.status !== testCourse.status) {
            console.log('  ❌ STATUS MISMATCH!');
          }
        }
      }
      
      // Find July course
      const julyCourse = allCourses.find(c => 
        c.title && (c.title.includes('July') || c.title === 'July 30')
      );
      
      if (julyCourse) {
        console.log('\n🎯 JULY COURSE FOUND:');
        console.log('  Title:', julyCourse.title);
        console.log('  ID:', julyCourse.courseId || julyCourse.id);
        console.log('  Status:', julyCourse.status);
        
        // Get its details
        const julyId = julyCourse.courseId || julyCourse.id;
        const julyResponse = await get({
          apiName: 'CourseBookingApi',
          path: `courses/${julyId}`,
          options: {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        });
        
        let julyDetail = julyResponse;
        if (julyResponse.response) julyDetail = await julyResponse.response;
        if (julyDetail.json) julyDetail = await julyDetail.json();
        if (julyDetail.body && julyDetail.body.text) {
          const bodyText = await julyDetail.body.text();
          julyDetail = JSON.parse(bodyText);
        } else if (typeof julyDetail.body === 'string') {
          julyDetail = JSON.parse(julyDetail.body);
        }
        
        console.log('  Detail status:', julyDetail.status);
        console.log('  Status JSON:', JSON.stringify(julyDetail.status));
        
        if (julyCourse.status !== julyDetail.status) {
          console.log('  ❌ STATUS MISMATCH!');
          console.log('  List shows:', julyCourse.status);
          console.log('  Detail shows:', julyDetail.status);
        }
      }
    } else {
      console.log('All courses response is not an array:', allCourses);
    }
    
  } catch (error) {
    console.error('Check failed:', error);
  }
}

window.directCourseCheck = directCourseCheck;